import {Injectable} from '@angular/core';

/**
 * Used ionic stroage, but moved to local storage
 */
@Injectable({
    providedIn: 'root'
})
export class StorageService
{

    set(key: StorageKey, value: any): Promise<any>
    {
        return new Promise((resolve) => {
            localStorage.setItem(key, JSON.stringify(value));
            resolve(true);
        });
    }

    get(key: StorageKey): Promise<any>
    {
        return new Promise((resolve) => {
            const value = localStorage.getItem(key);
            try {
                // Check if value is a string
                if (typeof value === 'string') {
                    resolve(JSON.parse(value));
                } else {
                    resolve(value);
                }
            } catch (error) {
                resolve(null);
            }
        });
    }

    remove(key: StorageKey): Promise<any> {
        return new Promise((resolve) => {
            localStorage.removeItem(key);
            resolve(true);
        });
    }
}

export type StorageKey = 'onboarding-selection'
    |'contacts'
    |'contacts_imported_at'
    |'session_data'
    |'settings'
    |'user_credentials'
    |'fb-dont-notify'
    |'fb_sent_count'
    |'skills'
    |'loginUnlockAt'
    |'loginAttempts'
    |'contactAuthorizationAttempt'
    ;
